<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<!-- -------- START PRE-FOOTER 1 w/ SUBSCRIBE BUTTON AND IMAGE ------- -->
<section style="{style(block)}">
  <div class="container-fluid px-0">
    <div class="row justify-content-center text-center"
         style="background: center / cover no-repeat url(/assets/img/bg-image.png); color: #fafafa">
      <div class="col-12 position-relative">
        <div class="row bg-warning-soft bottom-0 py-7">
          <div class="col-xl-6 text-start ms-auto">
            <h4>{text(block, 'headline')}</h4>
            <p class="mb-4">
              {@html richtext(block, 'body')}
            </p>
            <div class="row">
              <div class="col-sm-5">
                <div class="input-group">
                  <input type="text" class="form-control mb-sm-0 mb-2" placeholder="Email Here...">
                </div>
              </div>
              <div class="col-sm-4">
                <button type="button" class="btn mb-0 h-100 position-relative z-index-2">Subscribe</button>
              </div>
            </div>
          </div>

          <div class="col-xl-4 position-relative">
            <img class="w-100 border-radius-section border-top-end-radius-0 border-bottom-end-radius-0 end-0 position-absolute max-width-300 mt-n10 d-xl-block d-none"
                 src="{image(block, 'background', [350, 600])}"
                 alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- -------- END PRE-FOOTER 1 w/ SUBSCRIBE BUTTON AND IMAGE ------- -->
